var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 15 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#3E4E5D",
  d: "M5.797 4.378 7.83.805l2.033 3.573.108.189.21.05 3.867.922-2.611 3.245-.124.154.015.197.315 4.185-3.586-1.616-.204-.092-.204.092-3.627 1.616.354-4.18.017-.203-.128-.156-2.643-3.234 3.858-.93.21-.05z"
})));
export default SvgStar;